import { useTLang } from 'intl/intl';

import type { SubstitutionFlowStatus } from 'shared/domain';

export function useSubstitutionFlowStatusAlertLang(props: Props) {
  const {
    status,
    itemWasDeleted,
    outstockItemName,
    itemReplacementName,
  } = props;
  const langStrongAttention = useTLang({ id: 'substitutionFlow.033' });
  const label = {
    awaiting: {
      strong: useTLang({ id: 'substitutionFlow.031' }),
      sentence: useTLang({ id: 'substitutionFlow.032' }),
    },
    timeout: {
      strong: langStrongAttention,
      sentence: useTLang({ id: 'substitutionFlow.034' }),
    },
    another: {
      strong: langStrongAttention,
      sentence: useTLang({ id: 'substitutionFlow.035' }),
    },
    accepted: {
      strong: useTLang({ id: 'substitutionFlow.048' }),
      sentence: useTLang(
        { id: 'substitutionFlow.049' },
        { x: outstockItemName ?? '', y: itemReplacementName ?? '' },
      ),
    },
    refused: { strong: '', sentence: '' },
    chat: {
      strong: langStrongAttention,
      sentence: useTLang({ id: 'substitutionFlow.036' }),
    },
    deleted: {
      strong: langStrongAttention,
      sentence: useTLang({ id: 'substitutionFlow.050' }),
    },
  };
  const key: keyof typeof label = itemWasDeleted
    ? 'deleted'
    : status ?? 'refused';
  return {
    strong: label[key].strong,
    sentence: label[key].sentence,
  };
}

interface Props {
  status: SubstitutionFlowStatus | undefined;
  itemWasDeleted: boolean;
  outstockItemName: string | undefined;
  itemReplacementName: string | undefined;
}
